import { TParseJackpotsReturn } from '@interlayer/js/hooks/useGetJackpots/sun/types';

import { actionTypes } from './constants';

export const fetchExternalJackpot = ({ externalJackpots }: { externalJackpots?: TParseJackpotsReturn }) => ({
    type: actionTypes.JACKPOTS_EXTERNAL_FETCH,
    payload: externalJackpots
});
